import axiosMain from '@/plugins/axios/config';
import axiosV1 from '@/plugins/axios/configV1';
export default {
  async login(...payload) {
    return axiosMain.post('admin/login', ...payload);
    // await new Promise(resolve => setTimeout(resolve, 1000));
    
    // return Promise.resolve({
    //   data: {
    //     token: "http://alpha-canonph-app.eba-mfttrmik.ap-southeast-1.elasticbeanstalk.com/account/reset-password/3c01cb7d3b16215d2d173d4bbbb2085b2e63f122618d98529b20bc4e1a8e7dd3?email=mark%2B1%40thinkbitsolutions.com",
    //     user: {
    //       email: "mark+1@thinkbitsolutions.com",
    //       first_name: "Mark",
    //       last_name: "Hernandez",
    //       middle_name: null,
    //       name: "Mark Hernandez",
    //       role: "",
    //       salutation: null,
    //       suffix: null,
    //     }
    //   }
    // }) 
  },
  forgotPassword(email=null) {
    return axiosMain.post('password/email', { email: email })
  },
  checkLinkExpiry(params) {
    return axiosMain.get('link/reset-password', { params });
  },
  resetPassword(...payload) {
    return axiosMain.post('password/reset', ...payload)
  },
  getCurrentPermissions(...payload) {
    return axiosV1.get('users/admins/permissions', ...payload);
  },
  acceptCookies() {
    return axiosMain.post('/accept-cookies');
  },
  removeCookies() {
    return axiosMain.post('/remove-cookies');
  },
};
